// components/SkeletonAbout.jsx
import Skeleton from "react-loading-skeleton";

const SkeletonAbout = () => {
  return (
    <>
      <header>
        <h2 className="h2 article-title">
          <Skeleton width={120} height={24} />
        </h2>
      </header>

      {/* about text */}
      <section className="about-text space-y-3">
        <Skeleton count={3} height={14} />
      </section>

      {/* service */}
      <section className="service mt-6">
        <h3 className="h3 service-title">
          <Skeleton width={150} height={20} />
        </h3>
        <ul className="service-list grid gap-4 mt-4">
          {Array(4)
            .fill(null)
            .map((_, idx) => (
              <li className="service-item flex gap-4" key={idx}>
                <div className="service-icon-box">
                  <Skeleton circle width={40} height={40} />
                </div>
                <div className="service-content-box flex-1">
                  <h4 className="h4 service-item-title">
                    <Skeleton width="60%" height={18} />
                  </h4>
                  <p className="service-item-text">
                    <Skeleton count={2} height={14} />
                  </p>
                </div>
              </li>
            ))}
        </ul>
      </section>

      {/* testimonials */}
      <section className="testimonials mt-8">
        <h3 className="h3 testimonials-title">
          <Skeleton width={140} height={20} />
        </h3>
        <ul className="testimonials-list has-scrollbar flex gap-4 mt-4">
          {Array(3)
            .fill(null)
            .map((_, idx) => (
              <li className="testimonials-item" key={idx}>
                <div className="content-card p-4">
                  <figure className="testimonials-avatar-box mb-2">
                    <Skeleton circle width={60} height={60} />
                  </figure>
                  <h4 className="h4 testimonials-item-title">
                    <Skeleton width={100} height={16} />
                  </h4>
                  <div className="testimonials-text mt-2">
                    <Skeleton count={2} height={14} />
                  </div>
                </div>
              </li>
            ))}
        </ul>
      </section>

      {/* clients */}
      <section className="clients mt-8">
        <h3 className="h3 clients-title">
          <Skeleton width={100} height={20} />
        </h3>
        <ul className="clients-list has-scrollbar flex gap-4 mt-4">
          {Array(5)
            .fill(null)
            .map((_, idx) => (
              <li className="clients-item" key={idx}>
                <Skeleton width={80} height={40} />
              </li>
            ))}
        </ul>
      </section>
    </>
  );
};

export default SkeletonAbout;
